import { render, staticRenderFns } from "./ScoopRating.vue?vue&type=template&id=35c698d0&scoped=true&"
import script from "./ScoopRating.vue?vue&type=script&lang=js&"
export * from "./ScoopRating.vue?vue&type=script&lang=js&"
import style0 from "./ScoopRating.vue?vue&type=style&index=0&id=35c698d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c698d0",
  null
  
)

export default component.exports